import { render, staticRenderFns } from "./VideoPortal.vue?vue&type=template&id=6235ed05&scoped=true&"
import script from "./VideoPortal.vue?vue&type=script&lang=js&"
export * from "./VideoPortal.vue?vue&type=script&lang=js&"
import style0 from "./VideoPortal.vue?vue&type=style&index=0&id=6235ed05&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6235ed05",
  null
  
)

export default component.exports